if (!customElements.get('product-document-embed')) {
  const documentEmbeds = new Set();
  let documentObserver;
  let documentCheckScheduled = false;

  const isVisible = (element) => {
    if (!element.isConnected || !element.getClientRects().length) return false;

    // Tabs Studio collects the custom-liquid blocks after this script is parsed.
    // Wait until this component has been moved into its final tab panel.
    if (element.dataset.tabPanel === 'station-tabs' && !element.closest('.station-tabs-tabpanel')) {
      return false;
    }

    for (let current = element; current; current = current.parentElement) {
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }

    const rect = element.getBoundingClientRect();
    return rect.bottom >= -200 && rect.top <= window.innerHeight + 200;
  };

  const checkDocumentEmbeds = () => {
    documentCheckScheduled = false;
    documentEmbeds.forEach((embed) => embed.loadIfVisible());
  };

  const scheduleDocumentCheck = () => {
    if (documentCheckScheduled) return;

    documentCheckScheduled = true;
    window.requestAnimationFrame(checkDocumentEmbeds);
  };

  const observeDocumentTabs = () => {
    if (documentObserver || !document.body) return;

    documentObserver = new MutationObserver(scheduleDocumentCheck);
    documentObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden', 'aria-selected'],
      subtree: true
    });
    document.addEventListener('click', scheduleDocumentCheck, true);
    document.addEventListener('keyup', scheduleDocumentCheck, true);
    window.addEventListener('resize', scheduleDocumentCheck);
    window.addEventListener('scroll', scheduleDocumentCheck, { passive: true });
  };

  class ProductDocumentEmbed extends HTMLElement {
    connectedCallback() {
      if (this.frame || !this.dataset.documentUrl) return;

      documentEmbeds.add(this);
      observeDocumentTabs();
      scheduleDocumentCheck();
    }

    disconnectedCallback() {
      documentEmbeds.delete(this);
    }

    loadIfVisible() {
      if (this.frame || !this.dataset.documentUrl || !isVisible(this)) return;

      const frame = document.createElement('iframe');
      frame.className = 'absolute top-0 left-0 w-full h-full';
      frame.title = this.dataset.documentTitle || 'Product document';
      frame.src = this.dataset.documentUrl;
      frame.loading = 'lazy';
      frame.allow = 'clipboard-write';
      frame.setAttribute(
        'sandbox',
        'allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms'
      );
      frame.setAttribute('allowfullscreen', '');
      frame.style.border = '0';

      this.frame = frame;
      this.removeAttribute('data-document-url');
      this.append(frame);
    }
  }

  customElements.define('product-document-embed', ProductDocumentEmbed);
}
